export const es = {
  files: {
    dropZone: {
      primary: 'Haz clic aquí o arrastra un archivo a esta área',
      secondary: 'Puedes seleccionar uno o varios archivos',
    },
    retry: 'Reintentar',
    addedOn: 'Agregado el',
    loadingFiles: 'Cargando archivos...',
    saveFirst:
      'Por favor, guarda el registro primero antes de agregar archivos',
    uploadSuccess: (fileName: string) => `${fileName} se subió exitosamente`,
    uploadFailed: (fileName: string) => `Error al subir ${fileName}`,
    deleteSuccess: (fileName: string) => `${fileName} se eliminó exitosamente`,
    deleteFailed: (fileName: string, error: string) =>
      `Error al eliminar ${fileName}: ${error}`,
  },
  fields: {
    placeholder: {
      searchMaterial: 'Buscar un material...',
    },
  },

  selectFields: {
    CRMContact: {
      placeholder: 'Selecciona un contacto',
    },
    CRMAccount: {
      placeholder: 'Selecciona una cuenta',
    },
    CRMAccountAddress: {
      placeholder: 'Selecciona una dirección de cuenta',
    },
    CoreFacilityGroup: {
      placeholder: 'Selecciona un grupo de instalaciones',
    },
    CoreFacility: {
      placeholder: 'Selecciona una instalación',
    },
    CoreUser: {
      placeholder: 'Selecciona un usuario',
    },
    FilesFile: {
      placeholder: 'Selecciona un archivo',
    },
    FinanceFinancialAccount: {
      placeholder: 'Selecciona una cuenta financiera',
    },
    InventoryCategory: {
      placeholder: 'Selecciona una categoría',
    },
    InventoryItem: {
      placeholder: 'Selecciona un artículo',
    },
    InventoryItemGroup: {
      placeholder: 'Selecciona un grupo de artículos',
    },
    InventoryTag: {
      placeholder: 'Selecciona una etiqueta de inventario',
    },
    containerInstance: {
      placeholder: 'Selecciona un contenedor...',
      noContainersAvailable: 'No hay contenedores disponibles',
      unassignedContainer: 'Contenedor Sin Asignar',
      unknownType: 'Tipo Desconocido',
    },
  },

  containerStatus: {
    atPort: 'En Puerto',
    inTransitToFacility: 'En Tránsito a Instalación',
    atFacilityEmpty: 'En Instalación (Vacío)',
    atFacilityLoaded: 'En Instalación (Cargado)',
    inTransitToPort: 'En Tránsito a Puerto',
    atPortReadyToShip: 'En Puerto (Listo para Embarque)',
    shipped: 'Embarcado',
    voided: 'Anulado',
  },

  menu: {
    customerPortal: {
      root: 'Portal de Clientes',
      purchaseOrders: 'Órdenes de Compra',
      bookings: 'Reservas',
      loads: 'Cargas',
      bills: 'Facturas',
    },

    crm: {
      root: 'Gestión Cuentas',
      accounts: {
        root: 'Cuentas',
      },
    },

    facilities: {
      root: 'Instalaciones',
      locator: {
        root: 'Localizador de Instalaciones',
      },
      management: {
        root: 'Gestión de Instalaciones',
        groups: 'Grupos de Instalaciones',
        facilities: 'Instalaciones',
      },
    },

    files: {
      root: 'Archivos',
      explorer: 'Explorador de Archivos',
      shared: 'Compartidos Conmigo',
    },

    reports: {
      root: 'Reportes',
    },

    inventory: {
      root: 'Inventario',
      levels: 'Niveles de Inventario',
      lots: 'Lotes de Inventario',
      tags: 'Etiquetas de Inventario',
      periods: 'Periodos de Inventario',
      locations: 'Ubicaciones',
      zones: 'Zonas',
      cycleCountSchedules: 'Programas de Conteo',
      counts: 'Conteos Cíclicos',
    },

    office: {
      root: 'Oficina',
    },

    finance: {
      root: 'Finanzas',
      overview: 'Resumen',
      financialAccounts: 'Cuentas Financieras',
      balances: {
        root: 'Saldos',
      },
      bills: {
        root: 'Facturas',
      },
      invoices: {
        root: 'Facturas de Venta',
        overview: 'Resumen',
        history: 'Historial',
      },
      payments: {
        root: 'Pagos',
        list: 'Lista',
      },
    },

    trade: {
      root: 'Comercio',
      overview: 'Resumen',
      bookings: 'Reservas',
      loads: 'Cargas',
      containers: 'Contenedores',
      salesOrders: 'Órdenes de Venta',
      purchaseOrders: 'Órdenes de Compra',
      purchaseLoads: 'Cargas de Compra',
      positions: 'Posiciones',
      scaleTickets: 'Tickets de Báscula',
      transactions: 'Transacciones',
      sortingQueue: 'Cola de Clasificación',
      bookingTitle: (number: number) => `Reserva ${number}`,
      loadTitle: (number: number) => `Carga ${number}`,
      purchaseOrderTitle: (number: string) => `Orden de Compra ${number}`,
      purchaseLoadTitle: (number: number) => `Carga de Compra ${number}`,
      scaleTicketTitle: (number: number) => `Ticket de Báscula ${number}`,
      documents: 'Documentos',
      bookingDetail: 'Detalles de Reserva',
      loadDetail: 'Detalles de Carga',
      purchaseOrderDetail: 'Detalles de Orden de Compra',
      purchaseLoadDetail: 'Detalles de Carga de Compra',
      scaleTicketDetail: 'Detalles de Ticket de Báscula',
    },

    pricing: {
      root: 'Precios',
      variables: 'Variables',
      counterpartyGroups: 'Grupos de Precios',
      counterpartyGroupDetail: 'Grupo de Precios',
      defaultPriceList: 'Lista de Precios Predeterminada',
      customPriceLists: 'Listas de Precios Personalizadas',
      customPriceListDetail: 'Lista de Precios Personalizada',
    },

    brokerage: {
      root: 'Corretaje',
      orders: 'Órdenes de Corretaje',
      orderDetail: 'Detalles de Orden',
      quotes: 'Cotizaciones',
      quoteDetail: 'Detalles de Cotización',
      loads: 'Cargas de Corretaje',
      loadDetail: 'Detalles de Carga',
      commodities: 'Commodities',
    },

    settings: {
      organization: 'Organización',
      inventory: 'Inventario',
      settings: 'Configuración',
      customAttributes: 'Atributos Personalizados',
      jsonView: 'Vista JSON',
    },

    transportation: {
      root: 'Transporte',
      overview: 'Resumen',
      loadBoard: 'Tablero de Cargas',
      drivers: 'Conductores',
      trucksAndTrailers: {
        root: 'Camiones y Remolques',
        transportationTypes: 'Tipos de Transporte',
        trucks: 'Camiones',
        trailers: 'Remolques',
      },
      routes: 'Rutas',
      map: 'Mapa',
      assets: {
        root: 'Activos',
        list: 'Lista de Activos',
        types: 'Tipos de Activos',
      },
      freight: {
        root: 'Flete',
        lanes: 'Líneas de Flete',
        detentions: 'Detenciones',
      },
      settings: {
        root: 'Configuración',
        serviceTypes: 'Tipos de Servicio',
      },
    },

    calendar: {
      root: 'Calendario',
    },

    production: {
      root: 'Producción',
      workOrders: 'Órdenes de Trabajo',
      processingTypes: 'Tipos de Procesamiento',
      tollAgreements: 'Acuerdos de Maquila',
      tollProcessingAgreements: 'Maquila',
      tollReceipts: 'Recibos de Maquila',
      tollShipments: 'Envíos de Maquila',
    },

    automations: {
      root: 'Flujos de trabajo',
      workflows: 'Automatizaciones',
      approvals: 'Aprobaciones',
    },

    admin: {
      root: 'Administración',
      organizations: 'Organizaciones',
      users: 'Usuarios',
      aiManagement: 'Gestión de IA',
      agents: 'Agentes',
      aiAgents: 'Agentes',
      aiUsage: 'Uso',
      toolConfigurations: 'Configuraciones de Herramientas',
    },
  },

  touchModeSwitch: {
    label: 'Modo Táctil',
  },

  filters: {
    supplier: {
      placeholder: 'Buscar proveedores...',
    },
  },

  presence: {
    you: (name: string) => `${name} (Tú)`,
  },

  entityTabNotes: {
    internalNotes: 'Notas Internas',
    externalNotes: 'Notas Externas',
    discardChanges: 'Descartar Cambios',
    saveNotes: 'Guardar Notas',
    clearAll: 'Limpiar todo',
    addNotesPlaceholder: 'Agregar notas aquí...',
    hiddenFrom: (counterparty: string) => `Oculto de ${counterparty}`,
    visibleTo: (counterparty: string) => `Visible para ${counterparty}`,
  },

  pageNotFound: '404 - Página No Encontrada',

  auth: {
    signUp: {
      title: 'Crear su cuenta',
      subtitle: 'Ingrese su correo para comenzar',
      emailLabel: 'Correo electrónico',
      continue: 'Continuar',
      or: 'o',
      alreadyHaveAccount: '¿Ya tiene una cuenta?',
      signIn: 'Iniciar sesión',
      verificationEmailSent:
        '¡Se envió correo de verificación! Por favor revise su bandeja de entrada.',
      invalidCredentials: 'Correo electrónico o contraseña inválidos',
      unexpectedError: 'Ocurrió un error inesperado durante el registro',
    },
    checkEmail: {
      title: 'Revise su correo',
      sentVerificationLink: 'Hemos enviado un enlace de verificación a',
      linkExpiry:
        'Haga clic en el enlace del correo para completar la configuración de su cuenta. El enlace expirará en 7 días.',
      didntReceive: '¿No recibió el correo?',
      tryAgain: 'Intentar de nuevo',
      backToSignIn: 'Volver a iniciar sesión',
    },
    signUpSuccess: {
      defaultMessage: '¡Cuenta creada exitosamente!',
      canSignIn: 'Ahora puede iniciar sesión con sus credenciales',
      continueToSignIn: 'Continuar a Iniciar Sesión',
    },
    verifyEmail: {
      title: 'Completar su registro',
      subtitle:
        'Complete sus datos para finalizar la configuración de su cuenta',
      firstName: 'Nombre',
      lastName: 'Apellido',
      organizationName: 'Nombre de la Organización',
      timezone: 'Zona horaria',
      password: 'Contraseña',
      passwordPlaceholder: 'Mín. 8 caracteres',
      confirmPassword: 'Confirmar Contraseña',
      confirmPasswordPlaceholder: 'Vuelva a ingresar su contraseña',
      completeSetup: 'Completar Configuración',
      alreadyHaveAccount: '¿Ya tiene una cuenta?',
      signIn: 'Iniciar sesión',
      invalidLink: 'Enlace de verificación no válido',
      passwordsDoNotMatch: 'Las contraseñas no coinciden',
      passwordTooShort: 'La contraseña debe tener al menos 8 caracteres',
      passwordRequirements:
        'La contraseña no cumple los requisitos. Use una contraseña más segura con una combinación de mayúsculas, minúsculas, números y símbolos.',
      verificationFailed: (reason: string) =>
        `La verificación falló: ${reason}`,
      unexpectedError: 'Ocurrió un error inesperado durante la verificación',
    },
    acceptInvitation: {
      title: 'Establezca Su Contraseña',
      subtitle:
        'Ha sido invitado a unirse a la plataforma. Establezca su contraseña para completar su registro.',
      passwordLabel: 'Contraseña',
      passwordPlaceholder: 'Ingrese su contraseña',
      confirmPasswordLabel: 'Confirmar Contraseña',
      confirmPasswordPlaceholder: 'Confirme su contraseña',
      processing: 'Procesando...',
      submitButton: 'Establecer Contraseña y Completar Configuración',
      disclaimer:
        'Al establecer su contraseña, acepta acceder a la plataforma con esta cuenta.',
      success: '¡Éxito!',
      successMessage:
        'Su contraseña se ha establecido correctamente. Redirigiendo a iniciar sesión...',
      invitationError: 'Error de Invitación',
      invalidLink: 'Enlace de invitación no válido - falta el token',
      invalidInvitation: 'Invitación no válida',
      failedToAccept:
        'No se pudo aceptar la invitación. Por favor, intente de nuevo.',
      processingError:
        'Ocurrió un error al procesar su invitación. Por favor, intente de nuevo.',
      goToSignIn: 'Ir a Iniciar Sesión',
      passwordsDoNotMatch: 'Las contraseñas no coinciden',
    },
    customerInvitation: {
      title: 'Aceptar Invitación',
      subtitle: (accountName: string) =>
        `Ha sido invitado a acceder al portal de clientes de ${accountName}. Complete su registro a continuación.`,
      firstName: 'Nombre',
      firstNamePlaceholder: 'Ingrese su nombre',
      lastName: 'Apellido',
      lastNamePlaceholder: 'Ingrese su apellido',
      passwordLabel: 'Contraseña',
      passwordPlaceholder: 'Ingrese su contraseña',
      processing: 'Procesando...',
      submitButton: 'Aceptar Invitación y Crear Cuenta',
      disclaimer:
        'Al aceptar esta invitación, acepta crear una cuenta y acceder al portal de clientes.',
      success: '¡Éxito!',
      welcomeMessage: (orgName: string) =>
        `¡Bienvenido! Su cuenta ha sido creada para ${orgName}. Ahora puede iniciar sesión para acceder al portal de clientes.`,
      redirecting: 'Redirigiendo a iniciar sesión...',
      invitationError: 'Error de Invitación',
      loadingInvitation: 'Cargando invitación...',
      invalidLink: 'Enlace de invitación no válido - falta el token',
      expiredInvitation:
        'Esta invitación ha expirado. Contacte a la empresa para una nueva invitación.',
      alreadyAccepted:
        'Esta invitación ya ha sido aceptada. Ahora puede iniciar sesión para acceder al portal de clientes.',
      cancelledInvitation:
        'Esta invitación ha sido cancelada. Contacte a la empresa para una nueva invitación.',
      invalidToken:
        'Token de invitación no válido. Verifique su enlace de invitación e intente de nuevo.',
      loadError:
        'No se pudo cargar la invitación. Intente de nuevo o contacte a soporte.',
      failedToAccept:
        'No se pudo aceptar la invitación. Intente de nuevo o contacte a soporte.',
      processingError:
        'Ocurrió un error al procesar su invitación. Por favor, intente de nuevo.',
      goToSignIn: 'Ir a Iniciar Sesión',
    },
    signIn: {
      selectOrganization: 'Seleccione una Organización',
    },
  },
};
